<template>
    <div class="air-container air-container-subscribe-product-size-pop " :class="showAir ? 'air-container_active' :''">
        <div class="popup-air " :class="showAir ? ' popup-air_active' :''">
            <div class="air-close" @click="close()"></div>
            <div class="subscription-modal">
                <div class="form-header">
                    <h3 class="subscription-modal__title">{{ trans('Be the first to know') }}!</h3>
                </div>
                <div class="form-desc">
                    <p v-html="trans('Fill out the form to add this item to your wishlist and receive a notification when it`s back in stock')">
                    </p>
                </div>
                <form class="subscription-modal__form" style="flex-direction:column;">
                    <h3 class="size-title">{{ trans('Size') }}</h3>
                    <div class="input-wrapper">
                        <div class="select-size">
                            <div class="select-size__header input-wrapper__element-inp" @click="show_size = !show_size"
                                 :class="show_size ? 'select-active':''">
                                <p class="select-size__header-title sex-select__title">
                                   {{currentSize?.code}}
                                </p>
                            </div>
                            <div class="select-size__body">
                                <ul class="list select-size__list" v-show="show_size"
                                    :class="show_size ? 'select-size__body_displayed':''">
                                    <li v-for="size in unavailalbeSizes" @click="setSize(size)" class="list__element select-size__element">
                                        <span class="select-size__element-value">{{ size.code }}</span>
                                        <span class="select-size__element-value"></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="input-wrapper">
                        <input v-model="email" type="text" name="email" placeholder="email" class="input-element input-wrapper__element-inp input-wrapper__element-inp-js">
                    </div>
                    <div class="input-wrapper">
                        <label class="input-wrapper__title input-checkbox__wrapper subscribe-form__checkbox-title">
                            <input v-model="checkbox" type="checkbox" class="input-checkbox" name="agreement" id="agreement">
                            <span class="privacy" v-html="trans('I agree to receive information about news, promotions, and special offers in accordance with the Privacy Policy.')"></span>
                        </label>
                    </div>
                    <button :disabled="subscribeButton" @click.prevent="subscribe" style="max-height: 42px;" class="btn btnV2 subscription-modal__button-js">
                        {{ trans('Notify upon admission') }}
                    </button>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import store from '../../store.js';

export default {
    name: 'ProductSizeSubscription',
    props: {
        currentSizeId: {
            type: Number,
            default: 0
        },
        sizes: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            email:'',
            checkbox: true,
            show_size: false,
            subscribeButton: false,
            showAir: false,
            unavailalbeSizes: [],
            currentSize: {},
            offersList: []
        }
    },
    mounted() {
        this.unavailalbeSizes = this.getUnavailableSizes();
        if (this.offerInList(this.currentSize.offer_id)) {
            this.subscribeButton = false
        }
    },
    watch: {
        sizeClickEvent() {
            if (this.showAir === false && this.currentSize.id === this.currentSizeId) {
                this.showAir = true;
            }
        },
        currentSizeId(value) {
            const size = this.unavailalbeSizes.find(size => size.id === value);
            if (size) {
                this.currentSize = size
                this.showAir = true
            }
        },
        sizes(value) {
            this.unavailalbeSizes = this.getUnavailableSizes();
        }
    },
    methods: {
        close() {
            this.showAir = false
            this.$emit('update:currentSizeId', 0);
        },
        validateEmail() {
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            return emailRegex.test(this.email)
        },
        async subscribe() {
            let errorsExists = false
            if (!this.currentSize?.id) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Specify the size'),
                    type: 'error',
                });
                errorsExists = true
            }
            if (!this.checkbox) {
                this.$notify({
                    title: this.trans('Error'),
                    text:  this.trans('You must agree to the terms and conditions'),
                    type: 'error',
                });
                errorsExists = true
            }
            if(this.email.length === 0){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Fill in the email'),
                    type: 'error',
                });
                errorsExists = true
            }else if(!this.validateEmail()){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
                errorsExists = true
            }

            if (errorsExists === true) {
                return false
            }

            this.subscribeButton = true;

            await axios.post('/api/v1/set-subscribe-product-size',
                this.setParam({
                    email: this.email,
                    guest: this.$store.state.settings.guest.id,
                    offer_id: this.currentSize.offer_id,
                    gender: this.$store.state.settings.gender
                })
            )
            .then(data => {
                if(data.data.status === 'success'){
                    this.close()
                    this.$notify({
                        title: this.trans('Notification'),
                        text: data.data.text,
                        type: 'success',
                    });
                    localStorage.setItem('email-subscription-air-1', JSON.stringify({
                        'time': new Date().setFullYear(9999).toFixed(),
                        'subscribed': true
                    }))
                    if (!this.offerInList(this.currentSize.offer_id)) {
                        this.offersList.push(this.currentSize.offer_id)
                    }
                    this.showSubscribe = false
                    this.subscribeButton = false
                }
                if(data.data.status === 'error'){
                    this.$notify({
                        title: this.trans('Error'),
                        text: data.data.text,
                        type: 'error',
                    });
                }

            })
        },
        getUnavailableSizes() {
            let unavailableSizes = [];
            this.sizes.forEach((size) => {
                if (!size.purchase)
                    unavailableSizes.push(size)
            })
            return unavailableSizes
        },
        setSize(size) {
            this.show_size = false;
            this.currentSize = size
        },
        offerInList(offerId) {
            return this.offersList.includes(offerId)
        },
    }
};
</script>

<style lang="scss" scoped>
.size-title {
    margin-right: auto;
    margin-top: 10px;
    color: #000000;
    font-size: 12px;
    text-align: left;
    text-transform: uppercase;
}
.placeholder {
    color: #757575;
    line-height: 16px;
}
.text-red {
    color: #CF4D4D;
}
.subscription-modal__button-js{
    margin-top: 10px;
}
.privacy a{
    color: #3c3c3c;
    text-decoration: underline;
}
.air-container-subscribe-product-size-pop {
    .popup-air {
        padding: 20px;
        .air-close {
            top: 10px;
            right: 10px;
        }
        .subscription-modal {
            padding: 0;
            .picture-wrapper {
                position: relative;
                margin: -20px;
                margin-bottom: 20px;
                margin: 20px 0 40px 0;
                .subscription-modal__title {
                    font-size: 16px;
                    color: white;
                    text-align: center;
                    font-weight: 400;
                    text-transform: uppercase;
                }
            }
            .form-desc {
                margin-top: 20px;
                margin-bottom: 10px;
                max-width: 500px;
            }
            .form-desc p {
                font-size: 12px;
                line-height: 16px;
                text-transform: uppercase;
            }
            .subscription-modal__title {
                font-size: 18px;
                line-height: 20px;
                text-align: left;
                font-weight: 510;
            }
            .subscription-modal__form {
                .input-wrapper__element-inp {
                    background-color: #DFDEDE;
                }
                .select-size__header {
                    background-color: #ffffff !important;
                }
                .subscribe-form__checkbox-title{
                    text-transform: none;
                    font-size: 12px;
                    color: #3C3C3C;
                    span {
                        padding-left: 10px;
                        a {
                            color: #3C3C3C;
                            text-decoration: underline;
                        }
                    }
                }
                .input-wrapper {
                    margin-top: 15px;
                }
                .input-wrapper .select-size {
                    margin-top: 0 !important;
                }
                .input-wrapper .select-size__body {
                    border: none !important;
                }
            }
            .subscription-modal__image {
                img {
                    height: 100%;
                }
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .subscription-modal__form {
        align-items: center;
    }
    .air-container-subscribe-product-size-pop {
        .popup-air {
            margin: 0 20px;
            .subscription-modal {
                .picture-wrapper {
                    .subscription-modal__title {
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .form-header .subscription-modal__title{
        font-size: 14px !important;
    }
    .subscribe-form__checkbox-title{
        font-size: 10px !important;
    }
}
@media screen and (min-width: 800px) and (max-height: 800px){
    .picture-wrapper {
        height: 300px;
        img {
            object-fit: contain;
            object-position: top;
        }
    }
}
</style>
